import { setTheme } from "theme/default/setTheme";

export const setColor_00346e = setTheme(({ theme }) => `color: ${theme.colors.color_00346e}`);
